/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'
import { Spin, notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { GUILD_MESSAGE } from 'i18n/constants'
import { handleAsyncRequest } from 'utils/helper'
import useAppSelector from 'hooks/useAppSelector'
import guildApi from 'apis/guildApi'
import links from 'apps/links'
import UpgradeGuildContainer, { ButtonSyled } from './styled'
import Button from 'shared/Button'
import { STRING, NUMBER } from 'apps/constants'
import ModalConfirmEditGuild from 'features/Guild/components/ModalConfirmEditGuild'
import { GUILD_ARROW } from 'assets/images'
import IconMerahOrKuda from 'features/ShopAP/components/IconMerahOrKuda'

const UpgradeGuild = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [api, contextHolder] = notification.useNotification()
  const [loading, setLoading] = useState<boolean>(true)
  const { profile } = useAppSelector(state => state)
  const [showModalEditUpgrade, setShowModalEditUpgrade] = useState<boolean>(false)
  const [showModalErrorUpgrade, setShowModalErrorUpgrade] = useState<boolean>(false)
  const [errorMissing, setErrorMissing] = useState<any>(undefined)
  const [loadingUpgrade, setIsLoadingUpgrade] = useState<boolean>(false)
  const [upgradeGuildError, setUpgradeGuildError] = useState('')
  const [isMaxLevel, setIsMaxLevel] = useState<boolean>(false)
  const [upgradeData, setUpgradeData] = useState<any>(undefined)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [guildId, setGuildId] = useState<string>('')
  const [isShowAction, setIsShowAction] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    getManagerData()
  }, [profile])

  useEffect(() => {
    if (profile?.role_in_guild === 'MASTER') {
      setIsShowAction(true)
    }
  }, [profile])

  const getManagerData = async () => {
    const [error, result]: any = await handleAsyncRequest(guildApi.getGuildInformation())

    if (error) {
      openNotification('ERROR', error.message || error.errors[NUMBER.ZERO]?.message)
      if (error?.code === 'E1000') {
        navigate(links.guild.joinGuild())
      }
    }

    if (result) {
      setGuildId(String(result?.data?.id))
      const [errorUpgrade, upgradeResponse]: any = await handleAsyncRequest(guildApi.getUpgradeGuild(result?.data?.id))
      if (errorUpgrade) {
        openNotification('ERROR', errorUpgrade.message || errorUpgrade.errors[NUMBER.ZERO]?.message)
        if (errorUpgrade?.code === 'E1000') {
          navigate(links.guild.joinGuild())
        }
      }
      if (upgradeResponse) {
        const upgradeData = upgradeResponse?.data
        setUpgradeData(upgradeData)
        const { next_level, present_level } = upgradeData
        setIsMaxLevel(next_level?.id === present_level?.id)
      }
    }
    setLoading(() => false)
  }

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: NUMBER.FOUR
    })

    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === STRING.ERROR ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const handleShowModalEditUpgrade = async () => {
    setIsLoading(true)
    const [error, result]: any = await handleAsyncRequest(guildApi.checkConditionUpgrade(guildId))
    if (error) {
      setShowModalEditUpgrade(false)
      setShowModalErrorUpgrade(true)
      const [, resInfoUpgrade]: any = await handleAsyncRequest(guildApi.getUpgradeGuild(guildId))
      const info = resInfoUpgrade.data?.next_level
      setErrorMissing({
        missing_exp: info?.exp_to_level_up,
        missing_total_race: info?.total_race,
        missing_win_rate: info?.win_rate,
        missing_coins: info?.level_up_cost,
      })
    }
    if (result) {
      setShowModalEditUpgrade(true)
    }
    setUpgradeGuildError('')
    setIsLoading(false)
  }

  const handleConfirmEdit = async () => {
    setIsLoadingUpgrade(true)
    const [error, result]: any = await handleAsyncRequest(guildApi.postUpgradeGuild(guildId))
    setIsLoadingUpgrade(false)
    if (error) {
      setShowModalEditUpgrade(false)
      setShowModalErrorUpgrade(true)
      setErrorMissing({
        missing_exp: error.data?.missing_exp,
        missing_total_race: error.data?.missing_total_race,
        missing_win_rate: error.data?.missing_win_rate,
        missing_coins: error.data?.missing_coins,
      })
    }
    if (result) {
      setShowModalEditUpgrade(false)
      openNotification(STRING.SUCCESS, t(`${GUILD_MESSAGE}.message.edit_guild_guild`))
      setUpgradeGuildError('')
      const [errorUpgrade, upgradeResponse]: any = await handleAsyncRequest(guildApi.getUpgradeGuild(guildId))
      if (errorUpgrade) {
        openNotification('ERROR', errorUpgrade.message || errorUpgrade.errors[NUMBER.ZERO]?.message)
        if (errorUpgrade?.code === 'E1000') {
          navigate(links.guild.joinGuild())
        }
      }
      if (upgradeResponse) {
        const upgradeData = upgradeResponse?.data
        setUpgradeData(upgradeData)
        const { next_level, present_level } = upgradeData
        setIsMaxLevel(next_level?.id === present_level?.id)
        setIsEdit(false)
      }
    }
  }

  const checkRenderValue = (value: string | null | undefined | number, isPercent = false) => {
    if (value === '' || value === null || value === undefined || value === 'null') {
      return '---'
    }
    return isPercent ? `${value}%` : value
  }

  return (
    <UpgradeGuildContainer>
      {contextHolder}
      {loading || !upgradeData ? (
        <div className='loading'>
          <Spin className='mt-2 mr-3' />
        </div>
      ) : (
        <>
          <div>
            {isMaxLevel ? (
              <div className='form-content'>
                <div className='row-value max-level'>
                  <div className='title' />
                  <div className='present guild-name text-center'>{checkRenderValue(upgradeData?.present_level?.name)}</div>
                  <div className='arrow visible-hidden'>
                    <img src={GUILD_ARROW} alt='' className='icon-coin' width={25} />
                  </div>
                  <div className='next guild-name visible-hidden'>{checkRenderValue(upgradeData?.next_level?.name)}</div>
                </div>
                <div className='row-value max-level'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.manager`)}</div>
                  <div className='present text-center'>{checkRenderValue(upgradeData?.present_level?.max_manager)}</div>
                  <div className='arrow'>
                    {t(`${GUILD_MESSAGE}.max`)}
                  </div>
                  <div className='next visible-hidden'>{checkRenderValue(upgradeData?.next_level?.max_manager)}</div>
                </div>
                <div className='row-value max-level'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.member`)}</div>
                  <div className='present text-center'>{checkRenderValue(upgradeData?.present_level?.max_member)}</div>
                  <div className='arrow'>
                    {t(`${GUILD_MESSAGE}.max`)}
                  </div>
                  <div className='next visible-hidden'>{checkRenderValue(upgradeData?.next_level?.max_member)}</div>
                </div>
                <div className='row-value max-level'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.horse`)}</div>
                  <div className='present text-center'>{checkRenderValue(upgradeData?.present_level?.max_horse)}</div>
                  <div className='arrow'>
                    {t(`${GUILD_MESSAGE}.max`)}
                  </div>
                  <div className='next visible-hidden'>{checkRenderValue(upgradeData?.next_level?.max_horse)}</div>
                </div>
                <div className='row-value max-level'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.discountChangeNameFees`)}</div>
                  <div className='present text-center'>{checkRenderValue(upgradeData?.present_level?.discount_change_name_fees, true)}</div>
                  <div className='arrow'>
                    {t(`${GUILD_MESSAGE}.max`)}
                  </div>
                  <div className='next visible-hidden'>{checkRenderValue(upgradeData?.next_level?.discount_change_name_fees, true)}</div>
                </div>
                <div className='row-value max-level'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.discountHorseLevelUpFees`)}</div>
                  <div className='present text-center'>{checkRenderValue(upgradeData?.present_level?.discount_horse_level_up_fees, true)}</div>
                  <div className='arrow'>
                    {t(`${GUILD_MESSAGE}.max`)}
                  </div>
                  <div className='next visible-hidden'>{checkRenderValue(upgradeData?.next_level?.discount_horse_level_up_fees, true)}</div>
                </div>
                <div className='row-value max-level'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.expBonus`)}</div>
                  <div className='present text-center'>{checkRenderValue(upgradeData?.present_level?.exp_bonus, true)}</div>
                  <div className='arrow'>
                    {t(`${GUILD_MESSAGE}.max`)}
                  </div>
                  <div className='next visible-hidden'>{checkRenderValue(upgradeData?.next_level?.exp_bonus, true)}</div>
                </div>
                <div className='row-value max-level'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.buffHorseAttributeRandom`)}</div>
                  <div className='present text-center'>{checkRenderValue(upgradeData?.present_level?.buff_attributes, true)}</div>
                  <div className='arrow'>
                    {t(`${GUILD_MESSAGE}.max`)}
                  </div>
                  <div className='next visible-hidden'>{checkRenderValue(upgradeData?.next_level?.buff_attributes, true)}</div>
                </div>
              </div>
            ) : (
              <div className='form-content'>
                <div className='row-value'>
                  <div className='title' />
                  <div className='present guild-name'>{checkRenderValue(upgradeData?.present_level?.name)}</div>
                  <div className='arrow'>
                    <img src={GUILD_ARROW} alt='' className='icon-coin' width={25} />
                  </div>
                  <div className='next guild-name'>{checkRenderValue(upgradeData?.next_level?.name)}</div>
                </div>
                <div className='row-value'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.manager`)}</div>
                  <div className='present'>{checkRenderValue(upgradeData?.present_level?.max_manager)}</div>
                  <div className='arrow'>
                    <img src={GUILD_ARROW} alt='' className='icon-coin' width={25} />
                  </div>
                  <div className='next'>{checkRenderValue(upgradeData?.next_level?.max_manager)}</div>
                </div>
                <div className='row-value'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.member`)}</div>
                  <div className='present'>{checkRenderValue(upgradeData?.present_level?.max_member)}</div>
                  <div className='arrow'>
                    <img src={GUILD_ARROW} alt='' className='icon-coin' width={25} />
                  </div>
                  <div className='next'>{checkRenderValue(upgradeData?.next_level?.max_member)}</div>
                </div>
                <div className='row-value'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.horse`)}</div>
                  <div className='present'>{checkRenderValue(upgradeData?.present_level?.max_horse)}</div>
                  <div className='arrow'>
                    <img src={GUILD_ARROW} alt='' className='icon-coin' width={25} />
                  </div>
                  <div className='next'>{checkRenderValue(upgradeData?.next_level?.max_horse)}</div>
                </div>
                <div className='row-value'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.discountChangeNameFees`)}</div>
                  <div className='present'>{checkRenderValue(upgradeData?.present_level?.discount_change_name_fees, true)}</div>
                  <div className='arrow'>
                    <img src={GUILD_ARROW} alt='' className='icon-coin' width={25} />
                  </div>
                  <div className='next'>{checkRenderValue(upgradeData?.next_level?.discount_change_name_fees, true)}</div>
                </div>
                <div className='row-value'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.discountHorseLevelUpFees`)}</div>
                  <div className='present'>{checkRenderValue(upgradeData?.present_level?.discount_horse_level_up_fees, true)}</div>
                  <div className='arrow'>
                    <img src={GUILD_ARROW} alt='' className='icon-coin' width={25} />
                  </div>
                  <div className='next'>{checkRenderValue(upgradeData?.next_level?.discount_horse_level_up_fees, true)}</div>
                </div>
                <div className='row-value'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.expBonus`)}</div>
                  <div className='present'>{checkRenderValue(upgradeData?.present_level?.exp_bonus, true)}</div>
                  <div className='arrow'>
                    <img src={GUILD_ARROW} alt='' className='icon-coin' width={25} />
                  </div>
                  <div className='next'>{checkRenderValue(upgradeData?.next_level?.exp_bonus, true)}</div>
                </div>
                <div className='row-value'>
                  <div className='title'>{t(`${GUILD_MESSAGE}.buffHorseAttributeRandom`)}</div>
                  <div className='present'>{checkRenderValue(upgradeData?.present_level?.buff_attributes, true)}</div>
                  <div className='arrow'>
                    <img src={GUILD_ARROW} alt='' className='icon-coin' width={25} />
                  </div>
                  <div className='next'>{checkRenderValue(upgradeData?.next_level?.buff_attributes, true)}</div>
                </div>
              </div>
            )}
            {isShowAction && (
              <div className='button-edit'>
                {isEdit ? (
                  <>
                    <Button
                      buttonName={t(`${GUILD_MESSAGE}.btn_cancel`)}
                      onClickButton={() => setIsEdit(false)}
                      type='btnCancel'
                      width={150}
                      height={50}
                    />
                    <ButtonSyled>
                      <Button
                        buttonName={
                          <div className='btn-buy'>
                            <IconMerahOrKuda type='KUDA' price={upgradeData?.next_level?.level_up_cost} />
                          </div>
                        }
                        onClickButton={handleShowModalEditUpgrade}
                        width={150}
                        height={50}
                        isLoading={isLoading}
                        margingTop={true}
                      />
                    </ButtonSyled>
                  </>
                ) : (
                  <Button
                    buttonName={<div>{isMaxLevel ? t(`${GUILD_MESSAGE}.maxLevel`) : t(`${GUILD_MESSAGE}.upgradeAct`)}</div>}
                    onClickButton={() => setIsEdit(true)}
                    width={147}
                    disabled={isMaxLevel}
                  />
                )}
              </div>
            )}
          </div>
        </>
      )}

      {showModalEditUpgrade && (
        <ModalConfirmEditGuild
          onClose={() => setShowModalEditUpgrade(false)}
          onConfirm={handleConfirmEdit}
          titleModal={t(`${GUILD_MESSAGE}.information`)}
          loading={loadingUpgrade}
          content={
            <span>
              {`${t(`${GUILD_MESSAGE}.desUpgrage1`)} ${upgradeData?.next_level?.level_up_cost} KUDA.`}
              <br />
              {t(`${GUILD_MESSAGE}.areYouOk`)}
            </span>
          }
          error={upgradeGuildError}
          margingTop={true}
          widthM={550}
          heightM={285}
        />
      )}

      {/* {showModalTransferMoney && (
        <ModalConfirmEditGuild
          onClose={() => setShowModalTransferMoney(false)}
          onConfirm={handleActionTransfer}
          titleModal={t(`${GUILD_MESSAGE}.insufficient`)}
          loading={loadingUpgrade}
          content={
            <span>
              {t(`${GUILD_MESSAGE}.desInsufficient1`)}
              <br />
              {`${t(`${GUILD_MESSAGE}.desInsufficient2`)} ${coinTransfer} KUDA ${t(`${GUILD_MESSAGE}.desInsufficient3`)}`}
              <br />
              {t(`${GUILD_MESSAGE}.revenueToProceed`)}
            </span>
          }
          error={upgradeGuildError}
          margingTop={true}
          widthM={550}
          heightM={285}
        />
      )}

      {showModalErrorTransferMoney && (
        <ModalConfirmEditGuild
          onClose={() => setShowModalErrorTransferMoney(false)}
          onConfirm={() => setShowModalErrorTransferMoney(false)}
          titleModal={t(`${GUILD_MESSAGE}.insufficient`)}
          loading={loadingUpgrade}
          content={
            <span>
              {t(`${GUILD_MESSAGE}.failRevenueToProceed1`)}
              <br />
              {t(`${GUILD_MESSAGE}.failRevenueToProceed2`)}
            </span>
          }
          error={upgradeGuildError}
          margingTop={true}
          widthM={550}
          heightM={285}
        />
      )} */}

      {showModalErrorUpgrade && (
        <ModalConfirmEditGuild
          onClose={() => setShowModalErrorUpgrade(false)}
          onConfirm={() => setShowModalErrorUpgrade(false)}
          titleModal={t(`${GUILD_MESSAGE}.informationError`)}
          loading={loadingUpgrade}
          isOk
          contentClassName='text-start'
          contentBoxClassName={{ marginTop: '8px' }}
          content={
            <span>
              {t(`${GUILD_MESSAGE}.desInsufficient1`)}
              <br />
              {t(`${GUILD_MESSAGE}.desInsufficient2`)}
              {errorMissing?.missing_exp !== null && (
                <div className='message-error'>
                  <div className='message-field'>EXP:</div>
                  <div>{errorMissing?.missing_exp}</div>
                </div>
              )}
              {errorMissing?.missing_total_race !== null && (
                <div className='message-error'>
                  <div className='message-field'>Total Races:</div>
                  <div>{errorMissing?.missing_total_race}</div>
                </div>
              )}
              {errorMissing?.missing_win_rate !== null && (
                <div className='message-error'>
                  <div className='message-field'>Win Race:</div>
                  <div>{errorMissing?.missing_win_rate}</div>
                </div>
              )}
              {errorMissing?.missing_coins !== null && (
                <div className='message-error'>
                  <div className='message-field'>Upgrade Fee:</div>
                  <div>{errorMissing?.missing_coins} KUDA</div>
                </div>
              )}
            </span>
          }
          error={upgradeGuildError}
          margingTop={true}
          widthM={550}
          heightM={340}
        />
      )}
    </UpgradeGuildContainer>
  )
}

export default UpgradeGuild
